import type { SVGProps } from "react"

const IncompatiblePhoneDirect = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 350" {...props}>
    <defs>
      <clipPath id="prefix__a">
        <path data-name="Rectangle 3394" fill="none" d="M0 0h350v350H0z" />
      </clipPath>
    </defs>
    <g data-name="Group 8851" clipPath="url(#prefix__a)">
      <path
        data-name="Path 58880"
        d="M131.651 53.249h86.7a20.6 20.6 0 0120.6 20.6v203.368a20.6 20.6 0 01-20.6 20.6h-86.7a20.6 20.6 0 01-20.6-20.6V73.853a20.6 20.6 0 0120.6-20.6"
        fill="#fff"
      />
      <path
        data-name="Path 58881"
        d="M218.345 298.623h-86.7a21.431 21.431 0 01-21.4-21.406V73.853a21.431 21.431 0 0121.407-21.407h86.7a21.431 21.431 0 0121.407 21.407v203.364a21.431 21.431 0 01-21.414 21.406m-86.7-244.572a19.824 19.824 0 00-19.8 19.8v203.366a19.824 19.824 0 0019.8 19.8h86.7a19.824 19.824 0 0019.8-19.8V73.853a19.824 19.824 0 00-19.8-19.8z"
        fill="#98a300"
      />
      <path
        data-name="Path 58882"
        d="M159.48 281.231h32.112a1.338 1.338 0 010 2.676h-32.11a1.338 1.338 0 110-2.676"
        fill="#fff"
      />
      <path
        data-name="Path 58883"
        d="M191.59 284.709h-32.11a2.141 2.141 0 110-4.281h32.11a2.141 2.141 0 110 4.281m-32.11-2.676a.535.535 0 100 1.07h32.11a.535.535 0 000-1.07z"
        fill="#98a300"
      />
      <path
        data-name="Path 58884"
        d="M159.48 67.164h32.112a1.338 1.338 0 010 2.676h-32.11a1.338 1.338 0 010-2.676"
        fill="#fff"
      />
      <path
        data-name="Path 58885"
        d="M191.59 70.642h-32.11a2.141 2.141 0 010-4.281h32.11a2.141 2.141 0 110 4.281m-32.11-2.676a.535.535 0 100 1.07h32.11a.535.535 0 000-1.07z"
        fill="#98a300"
      />
      <path data-name="Rectangle 3390" fill="#f2f5cc" d="M111.047 84.289h127.905v182.492H111.047z" />
      <path
        data-name="Path 58886"
        d="M239.756 267.586H110.245v-184.1h129.511zm-127.905-1.605h126.3V85.091h-126.3z"
        fill="#98a300"
      />
      <path data-name="Rectangle 3391" fill="#98a300" d="M134.227 216.757l72.812-88.776 1.242 1.018-72.813 88.776z" />
      <path data-name="Rectangle 3392" fill="#98a300" d="M150.282 181.436l72.812-88.776 1.242 1.018-72.813 88.776z" />
      <path data-name="Rectangle 3393" fill="#98a300" d="M156.726 224.273l41.724-51.392 1.246 1.011-41.724 51.393z" />
      <path
        data-name="Path 58887"
        d="M248.706 215.84l21.676-21.676a1.544 1.544 0 000-2.185l-7.664-7.664a1.545 1.545 0 00-2.186 0l-21.676 21.675-21.675-21.675a1.545 1.545 0 00-2.186 0l-7.664 7.664a1.544 1.544 0 000 2.185l21.676 21.676-21.676 21.676a1.544 1.544 0 000 2.185l7.664 7.664a1.545 1.545 0 002.186 0l21.675-21.675 21.676 21.675a1.545 1.545 0 002.186 0l7.664-7.664a1.544 1.544 0 000-2.185z"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 58888"
        d="M261.625 183.862a1.541 1.541 0 011.093.453l7.664 7.662a1.544 1.544 0 010 2.185l-21.676 21.676 21.676 21.676a1.545 1.545 0 010 2.186l-7.664 7.664a1.545 1.545 0 01-2.186 0l-21.676-21.676-21.677 21.678a1.544 1.544 0 01-2.185 0l-7.664-7.664a1.545 1.545 0 010-2.186l21.676-21.676-21.676-21.676a1.544 1.544 0 010-2.185l7.664-7.664a1.544 1.544 0 012.185 0l21.676 21.676 21.676-21.676a1.541 1.541 0 011.093-.453m0-1.606a3.129 3.129 0 00-2.227.923l-20.542 20.541-20.54-20.543a3.151 3.151 0 00-4.456 0l-7.664 7.664a3.151 3.151 0 000 4.456l20.541 20.541-20.54 20.539a3.151 3.151 0 000 4.456l7.664 7.664a3.149 3.149 0 004.456 0l20.541-20.541 20.542 20.541a3.147 3.147 0 004.455 0l7.664-7.664a3.149 3.149 0 000-4.456l-20.541-20.541 20.541-20.541a3.149 3.149 0 000-4.456l-7.664-7.664a3.127 3.127 0 00-2.227-.923"
        fill="#98a300"
      />
    </g>
  </svg>
)
export { IncompatiblePhoneDirect }
